var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackroundLogoHornerosContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 740,
    viewBox: "0 0 680 740",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_130_84",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 680,
    height: 740
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 740,
    fill: "#EEECE6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_130_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.73 421.348C605.499 421.348 690.42 456.237 750.398 517.15C810.377 578.065 845.511 665.107 845.511 769.591C845.511 874.075 810.378 960.645 750.402 1021.09C690.426 1081.53 605.505 1115.96 505.73 1115.96C405.957 1115.96 321.27 1081.53 261.529 1021.09C201.787 960.648 166.886 874.078 166.886 769.591C166.886 665.107 202.021 578.064 261.885 517.149C321.747 456.235 406.434 421.348 505.73 421.348ZM505.73 440.933C370.171 440.933 254.163 574.493 254.163 768.651C254.163 962.806 369.228 1096.37 505.73 1096.37C641.284 1096.37 758.237 962.818 758.237 768.651C758.237 574.485 641.284 440.933 505.73 440.933Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.863 339.423C501.523 341.869 486.14 340.87 471.5 330.486C483.11 321.451 497.757 318.923 511.51 319.81C524.48 320.647 536.471 324.513 544.041 328.613C537.557 332.047 527.1 337.18 514.863 339.423Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1299 729.609C52.0387 729.907 50.9589 730.201 49.9037 730.477C65.9688 710.057 81.2346 679.987 94.037 647.925C106.437 616.871 116.568 583.84 122.895 555.686C123.041 556.686 123.215 557.766 123.449 558.965C110.342 612.232 90.7362 668.295 72.0118 721.661C68.5432 724.205 65.0334 725.959 60.6157 727.733C58.252 728.213 55.6763 728.915 53.1611 729.601L53.1299 729.609Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.713 321.108C447.454 330.586 433.911 337.875 417.441 335.897C421.914 323.11 432.876 313.119 445.004 306.221C456.47 299.699 468.726 296.085 476.979 295.465C473.701 301.894 467.161 312.379 457.713 321.108Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.629 447.384C245.728 452.501 230.135 454.361 213.828 446.629C223.362 435.764 237.165 430.382 250.931 428.383C264.018 426.484 276.899 427.67 285.671 429.978C280.134 435.152 270.562 442.652 258.629 447.384Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.863 356.383C458.438 361.086 468.769 368.329 474.502 373.132C465.999 375.35 452.591 376.31 438.842 374.316C424.28 372.204 409.626 366.821 400.033 356.424C415.907 349.195 432.146 351.254 445.863 356.383Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.914 396.683C206.935 384.388 214.414 374.445 219.247 369.142C221.38 377.213 221.938 390.396 219.518 403.967C216.964 418.296 211.15 432.721 200.734 441.896C193.96 426.054 196.454 410.056 201.914 396.683Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.779 495.376C173.504 482.599 187.184 475.413 201.015 471.955C214.087 468.687 227.127 468.794 235.896 470.561C230.394 476.46 221.167 485.696 209.457 492.121C196.845 499.041 181.477 502.641 164.779 495.376Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.651 543.722C165.282 551.75 152.474 556.571 138.181 550.692C143.83 537.377 155.083 528.861 166.898 524.068C178.049 519.545 189.491 518.422 196.839 519.605C192.767 525.964 185.378 536.192 175.651 543.722Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.661 597.013C146.89 605.563 134.068 611.516 118.504 607.805C123.756 594.982 134.529 585.85 145.973 580.072C156.802 574.605 168.013 572.252 175.331 572.533C172.141 578.852 165.792 589.024 156.661 597.013Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2381 540.095C77.2172 527.177 77.8642 514.425 79.0314 506.993C86.0007 512.07 94.6625 522.169 100.723 534.396C107.08 547.222 110.431 562.097 106.234 575.713C90.8832 567.827 83.4764 553.943 80.2381 540.095Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.768 488.116C112.692 473.951 116.806 461.217 119.668 453.98C124.684 461.759 129.864 475.093 132.079 489.653C134.422 505.05 133.401 521.487 125.698 534.025C113.553 520.544 110.761 503.567 111.768 488.116Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.524 311.661C392.083 302.821 403.03 297.083 409.865 294.303C408.337 302.531 403.473 314.55 395.803 325.583C387.691 337.251 376.618 347.558 363.362 351.205C363.549 334.345 372.166 321.239 382.524 311.661Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.95 371.548C386.531 376.151 396.846 383.381 402.221 388.146C393.723 390.387 380.266 391.374 366.557 389.476C352.1 387.474 337.685 382.308 328.532 372.36C343.986 364.693 360.223 366.526 373.95 371.548Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.543 331.985C329.496 322.648 340.837 316.48 347.808 313.261C346.239 321.992 341.15 334.854 333.157 346.633C324.687 359.117 313.148 370.098 299.434 373.782C299.615 355.976 308.702 342.155 319.543 331.985Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.389 414.617C298.363 415.953 282.745 413.413 269.339 401.27C281.797 393.531 296.904 392.304 310.909 394.305C324.155 396.197 336.228 400.952 343.816 405.573C336.849 408.851 325.335 413.385 312.389 414.617Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.198 360.151C261.621 348.755 271.812 339.698 278.135 334.995C279.356 342.92 278.428 355.476 274.106 368.02C269.521 381.328 261.203 394.372 247.899 401.808C241.626 386.98 246.248 372.357 254.198 360.151Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.975 439.03C156.287 425.989 162.765 414.777 167.066 408.599C170.692 416.298 173.77 429.391 173.665 443.235C173.553 457.87 169.887 473.005 159.916 483.408C149.546 469.178 149.397 453.12 152.975 439.03Z",
    stroke: "#98522E",
    strokeWidth: 2.9777
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackroundLogoHornerosContact);
export default __webpack_public_path__ + "static/media/backround-logo-horneros-contact.08cc8a901c70b48b8fd4c0ffcac6956f.svg";
export { ForwardRef as ReactComponent };